import * as services from '../services'
import * as TYPES from './mutations-types'

export const attemptGetArticlesList = ({ commit }, pagination) => {
  return services.getArticlesList(pagination)
    .then(response => {
      commit(TYPES.SET_ARTICLES_LIST, response.data.data)

      return {
        data: response.data.data,
        actualPage: response.data.actualPage,
        firstPage: response.data.firstPage,
        lastPage: response.data.lastPage,
        nextPage: response.data.nextPage,
        previousPage: response.data.previousPage,
        total: response.data.total
      }
    })
}

export const attemptToggleFeaturedArticle = (_, idArticle) => {
  return services.toggleFeaturedArticle(idArticle)
}

export const attemptPublishArticle = (_, idArticle) => {
  return services.publishArticle(idArticle)
}

export const attemptHideArticle = (_, idArticle) => {
  return services.hideArticle(idArticle)
}

export const attemptRemoveArticle = (_, idArticle) => {
  return services.removeArticle(idArticle)
}

export const attemptGetArticle = (_, idArticle) => {
  return services.getArticle(idArticle).then(response => response.data)
}

export const attemptCreateArticle = (_, payload) => {
  return services.createArticle(payload).then(response => response.data)
}

export const attemptUpdateArticle = (_, { idArticle, payload }) => {
  return services.updateArticle(idArticle, payload).then(response => response.data)
}

export const attemptCheckArticleSlug = (_, { slug, excludeId }) => {
  return services.checkArticleSlug(slug, excludeId).then(response => response.data)
}

export const attemptGetArticleThemesList = ({ commit }) => {
  return services.getThemesList().then(response => {
    const list = response.data?.data || response.data || []

    commit(TYPES.SET_ARTICLE_THEMES_LIST, list)

    return list
  })
}
